'use strict';

const PickerPresenter = require('./picker');

class QuantityPickerPresenter extends PickerPresenter {
  constructor() {
    super(...arguments);
    this.setModule('glive_booking_redesign');
  }

  toHash() {
    const hash = super.toHash(...arguments);
    if (this.selected()) {
      hash.selectedQuantity = { quantity: this.selected().getPartySize() };
    }
    hash.isTouch = this.collection.meta('isTouch');
    return hash;
  }
}

module.exports = QuantityPickerPresenter;
